export default __webpack_public_path__ + "img/refusal.22308aa.svg";